<div [formGroup]="form" *ngIf="form">

  <!-- string -->
  <div class="col-sm-10" *ngIf="fieldConfig.FieldType === FieldTypeString">
    <div class="col-sm-8">
      <mat-form-field class="full-width" >
        <input type="text" matInput [placeholder]="fieldConfig.FieldName|translate"
        [formControlName]="fieldConfig.FieldCode"  (change)="onChange($event)" 
          appUppercaseText *ngIf="uppercaseText">
          <!-- -->
        <input type="text" matInput [placeholder]="fieldConfig.FieldName|translate"
          [formControlName]="fieldConfig.FieldCode"  (change)="onChange($event)"
          *ngIf="!uppercaseText">

          <!--  -->
      </mat-form-field>
      <span *ngIf="fieldConfig.FieldDescription && !isServiceProvider">{{fieldConfig.FieldDescription}}</span>
    </div>
    <div class="col-sm-2"  *ngIf="fieldConfig.InformationText || fieldConfig.InformationImageID" (click)="onClickInfo()">
      <i class="fas fa-info-circle backwhite blue" 
        ></i>
    </div>
  </div>

  <!-- Text-Area -->
  <div class="col-sm-10" *ngIf="fieldConfig.FieldType === FieldTypeTextArea">
    <div class="col-sm-8">
      <mat-form-field class="full-width" >
        <textarea matInput [placeholder]="fieldConfig.FieldName|translate"
          [formControlName]="fieldConfig.FieldCode"  (change)="onChange($event)"
          *ngIf="!uppercaseText">
        </textarea>
      </mat-form-field>
      <span *ngIf="fieldConfig.FieldDescription && !isServiceProvider">{{fieldConfig.FieldDescription}}</span>
    </div>
    <div class="col-sm-2"  *ngIf="fieldConfig.InformationText || fieldConfig.InformationImageID" (click)="onClickInfo()">
      <i class="fas fa-info-circle backwhite blue" 
        ></i>
    </div>
    
  </div>
  
  <!-- number -->

  <div class="col-sm-10" *ngIf="fieldConfig.FieldType === FieldTypeNumber">
    <div class="col-sm-8">
      <mat-form-field class="full-width" >
        <input type="text" matInput [placeholder]="fieldConfig.FieldName|translate"
          [formControlName]="fieldConfig.FieldCode" 
          (change)="onChange($event)">
      </mat-form-field>
      <span *ngIf="fieldConfig.FieldDescription && !isServiceProvider">{{fieldConfig.FieldDescription}}</span>
    </div>
    <div class="col-sm-2"  *ngIf="fieldConfig.InformationText || fieldConfig.InformationImageID" (click)="onClickInfo()">
      <i class="fas fa-info-circle backwhite blue" 
        ></i>
    </div>
  </div>

  <!-- boolean -->
  <div class="col-sm-10" *ngIf="fieldConfig.FieldType === FieldTypeBoolean">
    <div class="col-sm-8">
      <mat-checkbox class="full-width" 
        [formControlName]="fieldConfig.FieldCode"  (change)="onChange($event)">
      {{fieldConfig.FieldName|translate|translate}}
      </mat-checkbox>
      <span *ngIf="fieldConfig.FieldDescription && !isServiceProvider">{{fieldConfig.FieldDescription}}</span>
    </div>
    <div class="col-sm-2"  *ngIf="fieldConfig.InformationText || fieldConfig.InformationImageID" (click)="onClickInfo()">
      <i class="fas fa-info-circle backwhite blue" 
        ></i>
    </div>
  </div>
  <!-- date -->
  <div class="col-sm-10" *ngIf="fieldConfig.FieldType === FieldTypeDate">
    <div class="col-sm-8">
      <mat-form-field class="full-width" >
        <input class="one date-picker" matInput [placeholder]="fieldConfig.FieldName|translate"
          [formControlName]="fieldConfig.FieldCode" 
          (change)="onChange($event)">
          <i matSuffix class="far fa-calendar-alt bigger-110"></i>
      </mat-form-field>
      <span *ngIf="fieldConfig.FieldDescription && !isServiceProvider">{{fieldConfig.FieldDescription}}</span>
    </div>
    <div class="col-sm-2"  *ngIf="fieldConfig.InformationText || fieldConfig.InformationImageID" (click)="onClickInfo()">
      <i class="fas fa-info-circle backwhite blue" 
        ></i>
    </div>
  </div>
  <!-- array -->
  <div class="col-sm-10" *ngIf="fieldConfig.FieldType === FieldTypeArray">
    <div class="col-sm-8">
      <mat-form-field class="full-width" >
        <mat-select [placeholder]="fieldConfig.FieldName|translate" [formControlName]="fieldConfig.FieldCode"
          (selectionChange)="onChange($event)">
          <mat-option>
            <ngx-mat-select-search [formControlName]="fieldConfig.FieldCode + 'Filter'"
              [placeholderLabel]="'SEARCH'|translate" [noEntriesFoundLabel]="'NO_RESULTS_WERE_FOUND'|translate">
              <i class="fas fa-times" ngxMatSelectSearchClear></i>
            </ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let item of filteredItems | async" [value]="item.ItemCode">
            <div *ngIf="item.ItemCode">
              <small>{{item.ItemName}}</small>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <span *ngIf="fieldConfig.FieldDescription && !isServiceProvider">{{fieldConfig.FieldDescription}}</span>
    </div>
    <div class="col-sm-2"  *ngIf="fieldConfig.InformationText || fieldConfig.InformationImageID" (click)="onClickInfo()">
      <i class="fas fa-info-circle backwhite blue" 
        ></i>
    </div>
  </div>
   <!-- Product Choose -->
   <div class="col-sm-10" *ngIf="fieldConfig.FieldType === FieldTypeChooseProduct">
    <div class="col-sm-8">
      <mat-form-field class="full-width" >
        <input matInput [placeholder]="fieldConfig.FieldName|translate"
          [formControlName]="fieldConfig.FieldCode" [disableControl]="isDisabled" (change)="onChange($event)"
          *ngIf="!uppercaseText" readonly = true (click)="setProductValue()">
          <i matSuffix class="glyphicon glyphicon-new-window" (click)="setProductValue()" *ngIf="!form.get(fieldConfig.FieldCode).disabled"></i>
      </mat-form-field>
      <span *ngIf="fieldConfig.FieldDescription && !isServiceProvider">{{fieldConfig.FieldDescription}}</span>
    </div>
    <div class="col-sm-2"  *ngIf="fieldConfig.InformationText || fieldConfig.InformationImageID" (click)="onClickInfo()">
      <i class="fas fa-info-circle backwhite blue"></i>
    </div>
  </div>
</div>